// extracted by mini-css-extract-plugin
export default {"wrapper":"registration-layuot_wrapper__K1y0l"};